import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import * as actions from '../../actions'
import { formatName } from '../../helpers'

class CommentChanger extends Component {
  constructor (props) {
    super(props)

    this.state = {
      comment: '',
      saving: false
    }

    this.onSubmit = this.onSubmit.bind(this)
  }

  componentDidMount () {
    this.setState({ comment: this.props.comment || '' })
  }

  onSubmit (ev) {
    ev.preventDefault()
    if (this.state.comment === this.props.comment || (!this.state.comment && !this.props.comment)) {
      this.props.dispatch(actions.displayAlert('There is no change to save.'))
      return
    }

    this.props.changeComment({ id: this.props.id, comment: this.state.comment })
    this.setState({ saving: true })
  }

  componentWillReceiveProps (nextProps) {
    nextProps.comment !== this.props.comment &&
      nextProps.close(nextProps.id)
  }

  render () {
    return (
      <div className='change-status-container'>
        {this.state.saving && <div className='saving-msg'>Saving...</div>}
        <div className='cell-subject changer-name'>
          {!this.props.owner &&
            <Link to={`/player/${this.props.id}`} target='_blank' className='color-inherit'>
              {formatName(this.props.name).length > 15 ? formatName(this.props.name).slice(0, 12) + '...' : formatName(this.props.name)}
            </Link>
          }
          {this.props.owner &&
            <Link to={`/team/${this.props.id}`} target='_blank' className='color-inherit'>
              {this.props.name.length > 15 ? this.props.name.slice(0, 12) + '...' : this.props.name}
            </Link>
          }
        </div>
        <form className='status-form comment-form' onSubmit={this.onSubmit}>
          <input
            type='text'
            className='comment-text'
            value={this.state.comment}
            onChange={ev => this.setState({ comment: ev.target.value })}
            ref='other' />
          <input type='submit' value='✓' className='button button-sm save-bttn cursor-pointer' />
          <input type='button' value='✕' className='button button-sm cancel-bttn cursor-pointer' onClick={() => this.props.close(this.props.id)} />
        </form>
      </div>
    )
  }
}

export default connect()(CommentChanger)



// WEBPACK FOOTER //
// ./src/screens/administration/CommentChanger.js